var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement } from '../typescript/TSXDomParse';
export default function MenuImage(_a) {
    var data = _a.data, className = _a.className;
    return (DOMcreateElement("img", __assign({}, ((className === null || className === void 0 ? void 0 : className.length) ? { className: className } : {}), { src: data.fields.image.fields.file.url, title: data.fields.image.fields.file.title })));
}
